import { StoreAction, XmAction } from 'store/actions';

import { Quickpayment, QuickpaymentMdnLookup, QuickpaymentResult } from './models';

export function quickpaymentReducer(state: Quickpayment, action: XmAction<Quickpayment>): Quickpayment {
    switch (action.type) {
        case StoreAction.SAVE_QUICKPAYMENT_DATA:
        case StoreAction.GET_QUICKPAYMENT_DATA:
        case StoreAction.CLEAR_QUICKPAYMENT_DATA:
            return action.payload;
        default:
            return state;
    }
}

export function quickpaymentMdnLookupReducer(state: QuickpaymentMdnLookup, action: XmAction<QuickpaymentMdnLookup>): QuickpaymentMdnLookup {
    switch (action.type) {
        case StoreAction.GET_QUICKPAYMENT_MDN_LOOKUP:
        case StoreAction.CLEAR_QUICKPAYMENT_MDN_LOOKUP:
            return action.payload;
        default:
            return state;
    }
}

export function quickpaymentResultReducer(state: QuickpaymentResult, action: XmAction<QuickpaymentResult>): QuickpaymentResult {
    switch (action.type) {
        case StoreAction.POST_QUICKPAYMENT:
        case StoreAction.CLEAR_QUICKPAYEMNT_RESULT:
            return action.payload;
        default:
            return state;
    }
}
